<template>
  <div class="roadmap__up">
    <div class="roadmap__up-right">
      <div class="roadmap__title">
        <div class="text-h4 mod--title">
          <span>{{ node.data.name }}</span>
          <IconCount
            v-if="node.data.events_unread_count"
            :count="node.data.events_unread_count"
          />
        </div>

        <div class="title__attention mod--event">
          <LKRoadmapsFeedAttentionDrop
            v-if="node.data.description"
            :description="node.data.description"
          />
        </div>
      </div>
    </div>

    <div class="up__label mod--roadmap">
      <LKRoadmapsFeedLabelConfirm
        :confirmed="node.data.is_confirmed"
      />

      <router-link v-if="hasLink" :to="roadmapLink">
        <IconLink />
      </router-link>
    </div>
    <div class="direction__up__footer text-sm mod--status-attention-card">
      Направлений, требующих внимания:
      {{ node.data.attention_count }}<br>
      <LKRoadmapsFeedTitleStatuses
        :node-data="node.data"
      />
    </div>
  </div>
</template>

<script>
import { LK_ROADMAPS_FEED_ROUTES } from '@/views/LKRoadmapsFeed/utils'

import IconLink from '@/components/lk/icons/LKIconLink.vue'
import IconCount from '@/components/lk/icons/LKIconCount.vue'
import LKRoadmapsFeedLabelConfirm from '../ui/LKRoadmapsFeedLabelConfirm.vue'
import LKRoadmapsFeedAttentionDrop from '../ui/LKRoadmapsFeedAttentionDrop.vue'
import LKRoadmapsFeedTitleStatuses from '../ui/LKRoadmapsFeedTitleStatuses.vue'


export default {
  name: 'LKRoadmapsFeedCardRoadmapUp',
  components: {
    IconLink,
    IconCount,
    LKRoadmapsFeedLabelConfirm,
    LKRoadmapsFeedAttentionDrop,
    LKRoadmapsFeedTitleStatuses,
  },
  inheritAttrs: false,
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasLink() {
      const currentLink = this.$route.fullPath
      return this.roadmapLink !== currentLink
    },
    roadmapLink() {
      const { node } = this

      const route = {
        name: LK_ROADMAPS_FEED_ROUTES.VIEW,
        params: {
          id: node.data.id,
          school_id: node.parent.data.id,
        },
      }

      const { resolved } = this.$router.resolve(route)
      return resolved.fullPath
    },
  },
}
</script>
